<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Report-of-Not-Received')}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Date-Type')" items-value="value" item-text="text" :items="itemstarihtip"
                          v-model="tarihTip"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="itemssatis"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.SirketNo }}</td>
                                    <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                                    <td class="text-xs-left">{{ props.item.Isim }}</td>
                                    <td class="text-xs-left">{{ props.item.CariKod }}</td>
                                    <td class="text-xs-left">{{ props.item.CariUnvan  }}</td>
                                    <td class="text-xs-left">{{ props.item.DurumKod }}</td>
                                    <td class="text-xs-left">{{ props.item.DurumAciklamasi }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaSeri}}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaNo }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaParaBirimi }}</td>
                                    <td class="text-xs-right">{{ props.item.SatisTutar | moneyformat }}</td>
                                    <td class="text-xs-right">{{ props.item.SatisFaturaTutar | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaSeri }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaNo }}</td>
                                    <td class="text-xs-right">{{ props.item.GelenFaturaTutar | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.KomisyonFaturaTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.KomisyonFaturaSeri  }}</td>
                                    <td class="text-xs-left">{{ props.item.KomisyonFaturaNo  }}</td>
                                    <td class="text-xs-right">{{ props.item.KomisyonTutar | moneyformat }}</td>
                                    <td class="text-xs-right">{{ props.item.KomisyonFaturaTutar | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiTip }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiKod }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAd }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiCariKod }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiCariUnvan }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaSaticiTip }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaSaticiAd }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaCariKod }}</td>
                                    <td class="text-xs-left">{{ props.item.GelenFaturaCariUnvan }}</td>
                                    <td class="text-xs-left">{{ props.item.TurOperatoru }}</td>
                                    <td class="text-xs-left">{{ props.item.MasrafMerkezi }}</td>
                                    <td class="text-xs-left">{{ props.item.MasrafMerkeziAdi }}</td>

                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                   {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details v-model="RaporGelen.FaturaNo1" :label="$t('Invoice-No') + '1'">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md6>

                              <v-text-field hide-details v-model="RaporGelen.FaturaNo2" :label="$t('Invoice-No') + '2'">
                              </v-text-field>

                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="RaporGelen.PNR_No" hide-details>
                              </pnrbul>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                            <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="RaporGelen.CariKod" v-model="RaporGelen.CariKod" :Coper="true"></cariaracomp>
                            </v-flex>
                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="RaporGelen.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="RaporGelen.SaticiTip"
                                :label="$t('Seller-Code')" v-model="RaporGelen.SaticiKod"></genelarama>

                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="RaporGelen.DurumKod">
                                <v-radio :label="$t('All-v2')" value="0"></v-radio>
                                <v-radio :label="$t('Invoiced-Ones')" value="1"></v-radio>
                                <v-radio :label="$t('Not-Invoiced-Ones')" value="2"></v-radio>
                                <v-radio :label="$t('With-Invoices')" value="3"></v-radio>
                                <v-radio :label="$t('Without-Invoices')" value="4"></v-radio>
                              </v-radio-group>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="RaporGelen.YurtIcDis">
                                <v-radio :label="$t('All-v2')" value="0"></v-radio>
                                <v-radio :label="$t('Domestic-v2')" value="1"></v-radio>
                                <v-radio :label="$t('Abroad')" value="2"></v-radio>
                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-layout justify-space-between column>
                                <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import parainput from '@/components/app/customcomp/parainput.vue'
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        tumsirketler:false,
        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,

        itemstarihtip: [{
          text: this.$t('Invoice-Date'),
          value: 0
        }, {
          text: this.$t('Check-in-Date'),
          value: 1
        }, {
          text: this.$t('Check-out-Date'),
          value: 2
        }, {
          text: this.$t('Registration-Date'),
          value: 3
        }],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,

        headerssatis: [{
            text: this.$t('Company-No'),
            value: "",
            width: "5%",
            align: "left"
          },
          {
            text: "PNR",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Name'),
            value: "PNR_RezzKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Currentcode_label'),
            value: "Kayit Tarihi",
            width: "5%",
            align: "left"
          },
          {
            text: "Cari Ünvan",
            value: "PNR_CariKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Situation-Code'),
            value: "SatisTutar",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Situation-Explanation'),
            value: "DurumAciklamasi",
            width: "5%",
            align: "left"
          }, {
            text: "Satış Fatura Tarih",
            value: "SatisFaturaTarih",
            width: "5%",
            align: "left"
          },
          {
            text: "Satış Fat. Seri",
            value: "SatisFaturaSeri",
            width: "5%",
            align: "left"
          }, {
            text: "Satış Fat. No",
            value: "SatisFaturaNo",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Sales-Currency-Type'),
            value: "SatisFaturaParaBirimi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Sales-Amount-v3'),
            value: "SatisTutar",
            width: "5%",
            align: "left"
          },
          {
            text: "Satış Fat. Tutar",
            value: "SatisFaturaTutar",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fat. Tarih",
            value: "GelenFaturaTarih",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fat. Seri",
            value: "GelenFaturaSeri",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fat. No",
            value: "GelenFaturaNo",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fatura Tutar",
            value: "GelenFaturaTutar",
            width: "5%",
            align: "left"
          },
          {
            text: "Komisyon Fat. Tarih",
            value: "KomisyonFaturaTarih",
            width: "5%",
            align: "left"
          },
          {
            text: "Komisyon Fat. Seri",
            value: "KomisyonFaturaSeri",
            width: "5%",
            align: "left"
          },
          {
            text: "Komisyon Fat. No",
            value: "KomisyonFaturaNo",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Commission-Amount-v2'),
            value: "KomisyonTutar",
            width: "5%",
            align: "left"
          },
          {
            text: "Komisyon Fat. Tutar",
            value: "KomisyonFaturaTutar",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Tip",
            value: "SaticiTip",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Kod",
            value: "SaticiKod",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Ad",
            value: "SaticiAd",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Cari",
            value: "SaticiCariKod",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Cari Ünvan",
            value: "SaticiCariUnvan",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fat. Satıcı Tip",
            value: "GelenFaturaSaticiTip",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fat. Satici Ad",
            value: "GelenFaturaSaticiAd",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fatura Satici Cari",
            value: "GelenFaturaCariKod",
            width: "5%",
            align: "left"
          },
          {
            text: "Gelen Fatura Cari Unvan",
            value: "GelenFaturaCariUnvan",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Tour-Operator'),
            value: "TurOperatoru",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Expense-Center-v2'),
            value: "MasrafMerkezi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Expense-Centre-Name'),
            value: "MasrafMerkeziAdi",
            width: "5%",
            align: "left"
          }
        ],

        Rapor: {
          PSirketNo: null, //eklendi
          PCariSirket: null, //eklendi
          PPNR_No: null, //eklendi
          PPNR_ParaBirimi: "TL", //eklendi
          PKayitTarihBas: null, //eklendi
          PKayitTarihBit: null, //eklendi
          PDonem1Bas: null, //eklendi
          PDonem1Bit: null, //eklendi
          PDonem2Bas: null, //eklendi
          PDonem2Bit: null, //eklendi
          PFatTarihBas: null, //eklendi
          PFatTarihBit: null, //eklendi
          PKomFatTarihBas: null, //eklendi
          PKomFatTarihBit: null, //eklendi
          PCariKod: null, //eklendi
          PSaticiTip: null, //eklendi
          PSaticiKod: null, //eklendi
          PDosyaTip: null,
          PDosya: null,
          PAcente: null,
          PPNRBir: null,
          PCariHesapGrubu: null, //eklendi
          PCariTip: null,
          PSaticiGrup: null, //eklendi
          PSaticiIc_Dis: null, //eklendi
          PTurOp: null, //eklendi
          PFaturali: null,
          POpsiyon: null, //eklendi
          PAnaTip: null, //eklendi
          PCariAnaHesap: null, //eklendi
          PIptalRaporu: null,
          PRezGrupID: null,
          PSatisGrubu: null,
          PSatisGrupTip: null,
          PSaticiOdemesiHesapla: null,
          PMasrafMerkezi: null, //eklendi
          PAcenteDepartmanID: null,
          PPozisyonNo: null,
          PSatisFaturaNo: null,
          PMusteriOdemelilerHaric: null,
          PReferans: null, //eklendi
          PSatisTip1: null,
          PSatisTip2: null,
          PSatisTip3: null,
          PSatisTip4: null,
          PGelenFatTarihBas: null, //eklen
          PGelenFatTarihBit: null, //eklendi
          PProfilSablonId: null,
          PKomisyonFaturali: null,
          PGelenFaturali: null,
        },

        RaporGelen: {
          Limit: 0,
          DurumKod: '0', //Tumu=0, FaturasiKesilenler = 1, FaturasiKesilmeyenler = 2, FaturasiGelenler = 3, FaturasiKelmeyenler = 4
          FaturaTarih1: null,
          FaturaTarih2: null,
          GirisTarih1: null,
          GirisTarih2: null,
          CikisTarih1: null,
          CikisTarih2: null,
          KayitTarih1: null,
          KayitTarih2: null,
          FaturaNo1: null,
          FaturaNo2: null,
          PNR_No: null,
          CariKod: null,
          SaticiTip: 0,
          SaticiKod: null,
          YurtIcDis: '0' //Tumu = 0, YurtIc
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,

    mounted() {
      this.el = this.$refs.fab.$el
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {
            this.$validator.localize("en", this.dictionary);
            this.el = this.$refs.fab.$el;
            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
              CompanyCode: credentials.SirketKodu
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader()
                }
              })
              .then(
                response => {
                  this.doviztipi = response.body;
                },
                response => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },





    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      parainput,
      cariaracomp
    },
    watch: {},
    methods: {

      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        ///var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
        //  window.open(url, "_target");
      },
      getList: getList,
      getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  };

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;
    this.RaporGelen.DurumKod = '0'
    this.RaporGelen.FaturaNo1 = null
    this.RaporGelen.FaturaNo2 = null
    this.RaporGelen.PNR_No = null
    this.RaporGelen.CariKod = null
    this.RaporGelen.SaticiTip = null
    this.RaporGelen.SaticiKod = null
    this.RaporGelen.YurtIcDis = '0'
    this.tumsirketler = false;
    this.getList();

  }

  function getList() {
    if (this.$refs.formgunluksatis.validate()) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

      if (this.tarihTip == 0) {

        this.RaporGelen.FaturaTarih1 = this.KayitTarihiBasla
        this.RaporGelen.FaturaTarih2 = this.KayitTarihiBitis

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null

       this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null


      } else if (this.tarihTip == 1) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = this.KayitTarihiBasla
        this.RaporGelen.GirisTarih2 = this.KayitTarihiBitis

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null

       this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null



      } else if (this.tarihTip == 2) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = this.KayitTarihiBasla
        this.RaporGelen.CikisTarih2 = this.KayitTarihiBitis


        this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null



      } else if (this.tarihTip == 3) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null

        this.RaporGelen.KayitTarih1=this.KayitTarihiBasla
        this.RaporGelen.KayitTarih2=this.KayitTarihiBitis

      }


      var credentials = JSON.parse(window.localStorage.getItem("credentials"));



      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;

        var RaporParam = {}

        RaporParam.Limit = this.RaporGelen.Limit
        RaporParam.DurumKod = this.RaporGelen.DurumKod
        RaporParam.FaturaTarih1 = this.RaporGelen.FaturaTarih1
        RaporParam.FaturaTarih2 = this.RaporGelen.FaturaTarih2
        RaporParam.GirisTarih1 = this.RaporGelen.GirisTarih1
        RaporParam.GirisTarih2 = this.RaporGelen.GirisTarih2
        RaporParam.CikisTarih1 = this.RaporGelen.CikisTarih1
        RaporParam.CikisTarih2 = this.RaporGelen.CikisTarih2
        RaporParam.KayitTarih1= this.RaporGelen.KayitTarih1
        RaporParam.KayitTarih2= this.RaporGelen.KayitTarih2
        RaporParam.FaturaNo1 = this.RaporGelen.FaturaNo1
        RaporParam.FaturaNo2 = this.RaporGelen.FaturaNo2
        RaporParam.PNR_No = this.RaporGelen.PNR_No
        RaporParam.SaticiTip = this.RaporGelen.SaticiTip
        RaporParam.YurtIcDis = this.RaporGelen.YurtIcDis


        if (this.RaporGelen.CariKod != null) {
          RaporParam.CariKod = this.RaporGelen.CariKod.id
        } else {
          RaporParam.CariKod = this.RaporGelen.CariKod
        }

        if (this.RaporGelen.SaticiKod != null) {
          RaporParam.SaticiKod = this.RaporGelen.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = this.RaporGelen.SaticiKod
        }
        RaporParam.tumSirketler = this.tumsirketler;
        RaporParam.sayfaAdi = this.$route.name;
        var params = RaporParam




        tool.http_post(this, "FaturasiGelenGelmeyenRaporu", params).then(
          response => {
            if (response.body.Status == true) {
              this.itemssatis = response.body.data;

              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          response => {
            this.HataYonetimi(response, params, 'Rapor Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function getListExcel() {
    if (this.$refs.formgunluksatis.validate()) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

          if (this.tarihTip == 0) {

        this.RaporGelen.FaturaTarih1 = this.KayitTarihiBasla
        this.RaporGelen.FaturaTarih2 = this.KayitTarihiBitis

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null
       this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null


      } else if (this.tarihTip == 1) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = this.KayitTarihiBasla
        this.RaporGelen.GirisTarih2 = this.KayitTarihiBitis

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null
       this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null



      } else if (this.tarihTip == 2) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = this.KayitTarihiBasla
        this.RaporGelen.CikisTarih2 = this.KayitTarihiBitis


        this.RaporGelen.KayitTarih1=null
        this.RaporGelen.KayitTarih2=null



      } else if (this.tarihTip == 3) {

        this.RaporGelen.FaturaTarih1 = null
        this.RaporGelen.FaturaTarih2 = null

        this.RaporGelen.GirisTarih1 = null
        this.RaporGelen.GirisTarih2 = null

        this.RaporGelen.CikisTarih1 = null
        this.RaporGelen.CikisTarih2 = null

        this.RaporGelen.KayitTarih1=this.KayitTarihiBasla
        this.RaporGelen.KayitTarih2=this.KayitTarihiBitis


      }

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));



      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;

        var RaporParam = {}

        RaporParam.Limit = this.RaporGelen.Limit
        RaporParam.DurumKod = this.RaporGelen.DurumKod
        RaporParam.FaturaTarih1 = this.RaporGelen.FaturaTarih1
        RaporParam.FaturaTarih2 = this.RaporGelen.FaturaTarih2
        RaporParam.GirisTarih1 = this.RaporGelen.GirisTarih1
        RaporParam.GirisTarih2 = this.RaporGelen.GirisTarih2
        RaporParam.CikisTarih1 = this.RaporGelen.CikisTarih1
        RaporParam.CikisTarih2 = this.RaporGelen.CikisTarih2
        RaporParam.KayitTarih1= this.RaporGelen.KayitTarih1
        RaporParam.KayitTarih2= this.RaporGelen.KayitTarih2
        RaporParam.FaturaNo1 = this.RaporGelen.FaturaNo1
        RaporParam.FaturaNo2 = this.RaporGelen.FaturaNo2
        RaporParam.PNR_No = this.RaporGelen.PNR_No
        RaporParam.SaticiTip = this.RaporGelen.SaticiTip
        RaporParam.YurtIcDis = this.RaporGelen.YurtIcDis
        RaporParam.tumSirketler = this.tumsirketler;
        RaporParam.sayfaAdi = this.$route.name;

        if (this.RaporGelen.CariKod != null) {
          RaporParam.CariKod = this.RaporGelen.CariKod.id
        } else {
          RaporParam.CariKod = this.RaporGelen.CariKod
        }

        if (this.RaporGelen.SaticiKod != null) {
          RaporParam.SaticiKod = this.RaporGelen.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = this.RaporGelen.SaticiKod
        }

        var params = RaporParam

        tool.api_post_FileDownload(this, "Coper/ExcelFaturasiGelenGelmeyen", params).then(
          response => {
            tool.CreateDownloadLink(response, 'CoperFaturasiGelenGelmeyen.xlsx');
            this.progress = false;
            this.load1 = true;

          },
          response => {
            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function beforeMount() {}
</script>
<style>
</style>